import { Cross } from '../buttons';
import { StyledDialog } from './Modal.styles';
import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { useWindowDimensions } from 'src/hooks';

interface Props {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  children: React.ReactNode;
  onClose?: () => void;
  'data-testid'?: string;
}

export const Modal = ({
  open,
  setOpen,
  onClose,
  children,
  ...props
}: Props) => {
  const { width } = useWindowDimensions();
  const ref = useRef<HTMLDialogElement>(null);
  const closeDialog = () => {
    setOpen(false);
  };

  useEffect(() => {
    ref.current?.addEventListener('close', () => {
      closeDialog();
    });
    return ref.current?.removeEventListener('close', () => {
      closeDialog();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (open) {
      document.body.style.overflowY = 'hidden';
      ref.current?.showModal?.();
    } else {
      document.body.style.overflowY = 'auto';
      ref.current?.close?.();
    }
    return () => {
      document.body.style.overflowY = 'auto';
    };
  }, [open]);

  return (
    <StyledDialog
      show={open}
      data-testid={`${props['data-testid']}-container`}
      ref={ref}
      screenWidth={width}
    >
      <Cross
        onClick={() => {
          if (onClose) {
            onClose();
          } else {
            setOpen(false);
          }
        }}
        data-testid={`${props['data-testid']}-close-button`}
        margin="24px 24px 0px 0px"
      />
      {children}
    </StyledDialog>
  );
};
